module.exports = __webpack_public_path__ + "static/media/createBtn.adef11ac.svg";